import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-pasta-grafik',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pasta-kapsayici">
      <svg viewBox="0 0 120 120" class="pasta-svg">
        @for (seg of segmentler(); track seg.idx) {
          <circle
            cx="60" cy="60" [attr.r]="R" fill="none"
            [attr.stroke]="seg.renk" [attr.stroke-width]="kalinlik"
            [attr.stroke-dasharray]="seg.dasharray"
            [attr.stroke-dashoffset]="seg.dashoffset"
            class="pasta-segment"
          />
        }
      </svg>
      <div class="pasta-legend">
        @for (seg of segmentler(); track seg.idx) {
          <div class="legend-item">
            <span class="legend-renk" [style.background]="seg.renk"></span>
            <span class="legend-etiket">{{ seg.etiket }}</span>
            <span class="legend-deger">{{ seg.yuzdeGosterim }}%</span>
          </div>
        }
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .pasta-kapsayici { display: flex; align-items: center; gap: 12px; }
    .pasta-svg { width: 80px; height: 80px; flex-shrink: 0; transform: rotate(-90deg); }
    .pasta-segment { transition: stroke-dasharray 0.5s, stroke-dashoffset 0.5s; }
    .pasta-legend { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
    .legend-item { display: flex; align-items: center; gap: 6px; font-size: 11px; }
    .legend-renk { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
    .legend-etiket { opacity: 0.7; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .legend-deger { font-weight: 600; margin-left: auto; flex-shrink: 0; }
  `],
})
export class PastaGrafikComponent {
  veriler = input<{ etiket: string; deger: number; renk: string }[]>([]);

  readonly R = 24;
  readonly kalinlik = 12;

  private cevre = computed(() => 2 * Math.PI * this.R);

  segmentler = computed(() => {
    const v = this.veriler();
    if (!v?.length) return [];
    const toplam = v.reduce((s, d) => s + d.deger, 0) || 1;
    const cev = this.cevre();
    let birikimOffset = 0;

    return v.map((d, idx) => {
      const oran = d.deger / toplam;
      const segUzunluk = oran * cev;
      const bosluk = cev - segUzunluk;
      const dashoffset = -birikimOffset;
      birikimOffset += segUzunluk;

      return {
        idx,
        renk: d.renk,
        etiket: d.etiket,
        yuzdeGosterim: Math.round(oran * 100),
        dasharray: `${segUzunluk} ${bosluk}`,
        dashoffset,
      };
    });
  });
}
